let BASE_URL, OSS_URL, GC_PROD_URL, GC_PAY_URL, GC_ACCESS_URL,GC_ACCESS_NEW_URL,GC_SHORT_URL, ACCOUNT_TYPE = 1000;
// @ts-ignore
console.log('ENV', ENV)
let GS_TC_URL = 'https://gcts-wechat.beta.shrise.cn/';
let MOCK_URL = 'http://127.0.0.1:4523/m1/4312044-5210081-default';

if(ENV === 'betax'){
  //BASE_URL = 'http://10.0.27.188:8106';
  BASE_URL = 'https://api-web-betax.shrise.cn';
  OSS_URL = 'https://tj-file-oss.cf69.com/';
  GC_ACCESS_URL = "https://gc-access-betax.shrise.cn/"
  GC_ACCESS_NEW_URL = "https://gc-access-new-betax.shrise.cn/"
  GC_PROD_URL = 'https://gc-prod-betax.shrise.cn/';
  GC_PAY_URL = 'https://gc-pay-betax.shrise.cn/';
  GC_SHORT_URL='https://gc-short-betax.shrise.cn/'
}
// @ts-ignore
else  if(ENV === 'beta0'){
  //BASE_URL = 'http://10.0.27.188:8106';
  BASE_URL = 'https://api-web-beta0.shrise.cn';
  OSS_URL = 'https://tj-file-oss.cf69.com/';
  GC_ACCESS_URL = "https://gc-access-new-beta0.shrise.cn/"
  GC_ACCESS_NEW_URL = "https://gc-access-new-beta0.shrise.cn/"
  GC_PROD_URL = 'https://gc-prod-beta0.shrise.cn/';
  GC_PAY_URL = 'https://gc-pay-beta0.shrise.cn/';
  GC_SHORT_URL='https://gc-short-beta0.shrise.cn/'
}
// @ts-ignore
else if (ENV === 'beta1') {
  BASE_URL = 'https://api-web-beta1.shrise.cn';
  OSS_URL = 'https://tj-file-oss.cf69.com/';
  GC_ACCESS_URL = "https://gc-access-new-beta1.shrise.cn/"
  GC_ACCESS_NEW_URL = "https://gc-access-new-beta1.shrise.cn/"
  GC_PROD_URL = 'https://gc-prod-beta1.shrise.cn/';
  GC_PAY_URL = 'https://gc-pay-beta1.shrise.cn/';
  GC_SHORT_URL='https://gc-short-beta1.shrise.cn/'
}
// @ts-ignore
else if (ENV === 'beta2') {
  BASE_URL = 'https://api-web-beta2.shrise.cn';
  OSS_URL = 'https://tj-file-oss.cf69.com/';
  // BASE_URL = 'https://api-admin-v2.shrise.cn';
  GC_ACCESS_URL = "https://gc-access-new-beta2.shrise.cn/"
  GC_ACCESS_NEW_URL = "https://gc-access-new-beta2.shrise.cn/"
  GC_PROD_URL = 'https://gc-prod-beta2.shrise.cn/';
  GC_PAY_URL = 'https://gc-pay-beta2.shrise.cn/';
  GC_SHORT_URL='https://gc-short-beta2.shrise.cn/'
}
// @ts-ignore
else if (ENV === 'beta3') {
  BASE_URL = 'https://api-web-beta3.shrise.cn';
  OSS_URL = 'https://tj-file-oss.cf69.com/';
  // BASE_URL = 'https://api-admin-v3.shrise.cn';
  GC_ACCESS_URL = "https://gc-access-new-beta3.shrise.cn/"
  GC_ACCESS_NEW_URL = "https://gc-access-new-beta3.shrise.cn/"
  GC_PROD_URL = 'https://gc-prod-beta3.shrise.cn/';
  GC_PAY_URL = 'https://gc-pay-beta3.shrise.cn/';
  GC_SHORT_URL='https://gc-short-beta3.shrise.cn/'
}
// @ts-ignore
else if (ENV === 'beta4') {
  BASE_URL = 'https://api-web-beta4.shrise.cn';
  OSS_URL = 'https://tj-file-oss.cf69.com/';
  // BASE_URL = 'https://api-admin-v4.shrise.cn';
  GC_ACCESS_URL = "https://gc-access-new-beta4.shrise.cn/"
  GC_ACCESS_NEW_URL = "https://gc-access-new-beta4.shrise.cn/"
  GC_PROD_URL = 'https://gc-prod-beta4.shrise.cn/';
  GC_PAY_URL = 'https://gc-pay-beta4.shrise.cn/';
  GC_SHORT_URL='https://gc-short-beta4.shrise.cn/'
}
// @ts-ignore
else if (ENV === 'beta5') {
  BASE_URL = 'https://api-web-beta5.shrise.cn';
  OSS_URL = 'https://tj-file-oss.cf69.com/';
  // BASE_URL = 'https://api-admin-v4.shrise.cn';
  GC_ACCESS_URL = "https://gc-access-new-beta5.shrise.cn/"
  GC_ACCESS_NEW_URL = "https://gc-access-new-beta5.shrise.cn/"
  GC_PROD_URL = 'https://gc-prod-beta5.shrise.cn/';
  GC_PAY_URL = 'https://gc-pay-beta5.shrise.cn/';
  GC_SHORT_URL='https://gc-short-beta5.shrise.cn/'
}
else if (ENV === 'beta6') {
    BASE_URL = 'https://api-web-beta6.shrise.cn';
    OSS_URL = 'https://tj-file-oss.cf69.com/';
    // BASE_URL = 'https://api-admin-v4.shrise.cn';
    GC_ACCESS_URL = "https://gc-access-new-beta6.shrise.cn/"
    GC_ACCESS_NEW_URL = "https://gc-access-new-beta6.shrise.cn/"
    GC_PROD_URL = 'https://gc-prod-beta6.shrise.cn/';
    GC_PAY_URL = 'https://gc-pay-beta6.shrise.cn/';
    GC_SHORT_URL='https://gc-short-beta6.shrise.cn/'
}
else {
  BASE_URL = 'https://api-web.cf69.cn';
  OSS_URL = 'https://tj-file-oss.cf69.com/';
  GS_TC_URL = 'https://wxts.cf69.cn/'
  GC_ACCESS_URL = "https://gc-access-new.cf69.cn/"
  GC_ACCESS_NEW_URL = "https://gc-access-new.cf69.cn/"
  GC_PROD_URL = 'https://gc-prod.cf69.cn/';
  GC_PAY_URL = 'https://gc-pay.cf69.cn/';
  GC_SHORT_URL='https://gc-short.cf69.cn/'
  ACCOUNT_TYPE = 1099;
}

const PRODUCT_TYPE = 171;
const COMPANY_TYPE = 45;
const WHITE_PAGE_LIST = ["/sku-detail","/env","/debug","/order/lakala-success","/order/lianl-success","/paySuccess/:orderNumber/:salesNumber","/authorization", "/skuInfoPre", "/skuInfo/:skuId/:salesNumber", "/orderPay/:orderNumber/:salesNumber", "/alreadyPayInfo/:orderNumber", "/payResult", '/order/unionPayResult']
export default {
  ACCOUNT_TYPE,
  PRODUCT_TYPE,
  GC_PAY_URL,
  GC_SHORT_URL,
  GC_PROD_URL,
  GS_TC_URL,
  BASE_URL,
  OSS_URL,
  GC_ACCESS_URL,
  GC_ACCESS_NEW_URL,
  WHITE_PAGE_LIST,
  COMPANY_TYPE,
  MOCK_URL,
}
